import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiHeaders } from '@core/core.types';
import { Scheme } from '@app/modules/configuration/configuration.types';
import { environment } from '@root/environments/environment';
import { HttpUtils } from '@core/utils/http-utils';
import { PAGING_HEADERS } from '@app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class SchemesService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/digital-reports/schemes`;

  getScheme(schemeId: string): Observable<Scheme> {
    return this.http.get<Scheme>(`${this.apiUrl}/${schemeId}`);
  }

  listSchemes(filters: HttpParams, headers: ApiHeaders) {
    return this.http
      .get<Scheme[]>(`${this.apiUrl}`, {
        observe: 'response',
        params: filters,
        headers: HttpUtils.buildHttpHeaders(headers),
      })
      .pipe(
        map((response) => ({
          items: response.body,
          continuationToken: response.headers.get(
            PAGING_HEADERS.continuationToken
          ),
          totalCount: parseInt(
            response.headers.get(PAGING_HEADERS.totalCount),
            10
          ),
        }))
      );
  }

  createScheme(scheme: Scheme) {
    return this.http.post<void>(`${this.apiUrl}`, scheme);
  }

  updateScheme(scheme: Scheme) {
    return this.http.put<Scheme>(`${this.apiUrl}/${scheme.id}`, scheme);
  }

  deactivateScheme(schemeId: string) {
    return this.http.patch(`${this.apiUrl}/${schemeId}/deactivate`, null);
  }

  activateScheme(schemeId: string) {
    return this.http.patch(`${this.apiUrl}/${schemeId}/reactivate`, null);
  }

  getFields() {
    return this.http.get<{ [AnalysisType: string]: string[] }>(
      `${this.apiUrl}/fields`
    );
  }
}
